import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import IconButton from 'componentes/common/IconButton.js';
import { isNullOrEmpty } from 'helpers/utils';

const QuejaDetalle = ({
  detalle,
  setOpenModalExpediente,
  setOpenModalFechaOportunidad,
  setOpenModalPreconciliacion,
  isOpen
}) => {
  return (
    <Card className="mb-3">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5 className="mb-0">Informacion Adicional de Queja</h5>
          </Col>
          <Col xs="auto">
            {isOpen && (
              <IconButton
                variant="falcon-default"
                iconClassName="fs-11 me-1"
                size="sm"
                icon="plus"
                transform="shrink-3"
                onClick={() => {
                  setOpenModalFechaOportunidad(true);
                }}
              >
                Agregar Oportunidad
              </IconButton>
            )}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="bg-body-tertiary border-top">
        <Row>
          <Col sm={2}>
            <p className="fw-normal mb-1">Expediente PIL</p>
          </Col>
          <Col>
            <Link
              className="mb-1 fst-italic fw-semibold"
              to="#"
              onClick={e => {
                e.preventDefault();
                setOpenModalExpediente(true);
              }}
            >
              {detalle?.expedientepil ?? 'No Capturado'}
            </Link>
          </Col>
          <Col sm={2}>
            <p className="fw-normal mb-1">Oportunidad</p>
          </Col>
          <Col>
            <p className="mb-1 fst-italic fw-semibold">
              {detalle?.oportunidad || ''}
            </p>
          </Col>
        </Row>

        <Row>
          <Col sm={2}>
            <p className="fw-normal mb-1">Descripcion Walmart</p>
          </Col>
          <Col sm={4}>
            <p className="mb-1 fst-italic fw-semibold">
              {detalle?.descripcionwm || ''}
            </p>
          </Col>
          <Col sm={3}>
            <p className="fw-normal mb-1">Fecha de Oportunidad</p>
          </Col>
          <Col>
            <p className="mb-1 fst-italic fw-semibold">
              {detalle?.fechaoportunidad || ''}
            </p>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <p className="fw-normal mb-1">Folio de preconciliacion de origen</p>
          </Col>
          <Col sm={8}>
            <Link
              className="mb-1 fst-italic fw-semibold"
              to="#"
              onClick={e => {
                e.preventDefault();
                setOpenModalPreconciliacion(true);
              }}
            >
              {isNullOrEmpty(detalle?.preconciliacion)
                ? 'No Capturado'
                : detalle?.preconciliacion}
            </Link>
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer className="border-top text-end">
        {/* <IconButton
          iconClassName="fs-11 me-1"
          variant="falcon-default"
          size="sm"
          icon="dollar-sign"
        >
          Refund
        </IconButton> */}
      </Card.Footer>
    </Card>
  );
};
QuejaDetalle.propTypes = {
  detalle: PropTypes.object.isRequired,
  setOpenModalExpediente: PropTypes.func.isRequired,
  setOpenModalPreconciliacion: PropTypes.func.isRequired,
  setOpenModalFechaOportunidad: PropTypes.func.isRequired,
  isOpen: PropTypes.bool
};
export default QuejaDetalle;
